var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"grey lighten-3",attrs:{"app":"","inset":""}},[_c('v-row',{staticClass:"mx-4"},[_c('v-col',{staticClass:"text-left grey--text",attrs:{"cols":"12"}},[_vm._v(" © 2019 ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }